import React, {FC, useState} from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import GatewayService, {DailyAnalyses} from "../service/GatewayService";
import AppUtil from "../util/AppUtil";
// @ts-ignore
// import faker from 'faker';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

export const options = {
    responsive: true,
    plugins: {
        legend: {
            position: 'top' as const,
        },
        title: {
            display: true,
            text: 'Chart.js Line Chart',
        },
    },
};

// let labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
let date = new Date()
let labels = [date, date, 'March', 'April', 'May', 'June', 'July'];
labels.push(...labels)
labels.push(...labels)
labels.push(...labels)
let count = 0
function getData(dailyAnalyses:DailyAnalyses[]){
    return {
        labels : dailyAnalyses.map(it=>it.date),
        datasets: [
            {
                label: 'profit by tax',
                data: dailyAnalyses.map(it=> it.analyses.profitByRules),
                borderColor: 'rgb(255, 99, 132)',
                backgroundColor: 'rgba(255, 99, 132, 0.5)',
            },
            {
                label: 'profit by exchanges',
                data: dailyAnalyses.map(it=> it.analyses.profitByExchange),
                borderColor: 'rgb(53, 162, 235)',
                backgroundColor: 'rgba(53, 162, 235, 0.5)',
            },
        ],
    }
}

export function App() {
    return<>
    </>
}
const DashboardComponent:FC = () => {
    const [group, setGroup] = useState(false)
    const [from, setFrom] = useState("2025-04-01")
    const [to, setTo] = useState("2026-03-31")
    const [data, setData] = useState(getData([]))
    const [totalProfit, setTotalProfit] = useState(0)
    const [totalProfitByExchange, setTotalProfitByExchange] = useState(0)
    function analyse(clientId: string) {
        GatewayService.analyse(from, to, clientId, group).then(it=>{
            setData(getData(it))
            setTotalProfit(it.map(it=>(it.analyses.profitByRules)).reduce(AppUtil.sum, 0))
            setTotalProfitByExchange(it.map(it=>(it.analyses.profitByExchange)).reduce(AppUtil.sum, 0))

        })
    }

    function toggleGroup() {
        setGroup(!group)
    }

    console.log(group)

    return<>
        <input type="text" value={from} onChange={event => setFrom(event.target.value)}/>
        <input type="text" value={to} onChange={event => setTo(event.target.value)}/>
        <button onClick={()=>analyse("ECA007")}>analyse tushar</button>
        <button onClick={()=>analyse("ICT895")}>analyse mom</button>
        <button onClick={()=>toggleGroup()}>group by month - {group+""}</button>
        <>total profit {AppUtil.getRoundedOff(totalProfit)}</>
        <> total profit by exchange {AppUtil.getRoundedOff(totalProfitByExchange)}</>
        <Line options={options} data={data} />;
    </>
}

export default DashboardComponent